module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "modalOverlayFade",
      "enter-active-class": "fadeIn",
      "leave-active-class": "fadeOut"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.modalVisible),
      expression: "modalVisible"
    }],
    staticClass: "modal is-active"
  }, [_c('transition', {
    attrs: {
      "name": "modalShowHide",
      "enter-active-class": "zoomIn",
      "leave-active-class": "zoomOut"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.modalVisible),
      expression: "modalVisible"
    }],
    staticClass: "modal-dialog"
  }, [_c('form', {
    staticClass: "modal-content form-horizontal",
    attrs: {
      "enctype": _vm.formEnctype
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.confirm($event)
      }
    }
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.closeModal
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('h2', {
    staticClass: "modal-title"
  }, [_vm._v(_vm._s(_vm.title))])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_vm._t("default")], 2), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_vm._t("footer"), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.closeModal
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), (_vm.localSubmitVisible) ? _c('button', {
    staticClass: "btn",
    class: _vm.buttonClass ? _vm.buttonClass : 'btn-primary',
    attrs: {
      "type": "submit"
    }
  }, [_vm._v(_vm._s(_vm.confirmButtonText))]) : _vm._e()], 2)])])])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2d5b2a16","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ModalDialog.vue
// module id = 281
// module chunks = 0